export const WIDGETS = {
  inDepth_default_combi: {
    id: "inDepth_default_combi",
    portalData: { phoneOffer: true, proposition: true, simOnly: true },
    options: {}
  },
  inDepth_default_phoneOffer: {
    id: "inDepth_default_phoneOffer",
    portalData: { phoneOffer: true, proposition: false, simOnly: false },
    options: {}
  },
  inDepth_default_proposition: {
    id: "inDepth_default_proposition",
    portalData: { phoneOffer: false, proposition: true, simOnly: false },
    options: {}
  },
  inDepth_default_simOnly: {
    id: "inDepth_default_simOnly",
    portalData: { phoneOffer: false, proposition: false, simOnly: true },
    options: {}
  },
  topList_default_proposition: {
    id: "topList_default_proposition",
    portalData: { phoneOffer: false, proposition: false, simOnly: false },
    options: { withRanks: true }
  },
  topList_default_simOnly: {
    id: "topList_default_simOnly",
    portalData: { phoneOffer: false, proposition: false, simOnly: false },
    options: { withRanks: true }
  },
  topList_inArticle_proposition: {
    id: "topList_inArticle_proposition",
    portalData: { phoneOffer: false, proposition: false, simOnly: false },
    options: { withRanks: false }
  },
  topList_inArticle_simOnly: {
    id: "topList_inArticle_simOnly",
    portalData: { phoneOffer: false, proposition: false, simOnly: false },
    options: { withRanks: false }
  }
};

export const DEFAULT_WIDGET = WIDGETS.topList_default_proposition.id;
